var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3048 1.875V3.65562M5.109 1.875V3.65562M11.8782 6.8V5.24C11.8824 3.61312 10.9344 2.72812 9.405 2.72812H5.0076C3.4824 2.72812 2.5296 3.61313 2.5296 5.24063V10.1356C2.5296 11.7881 3.4824 12.6937 5.0076 12.6937H6.1164",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4752 10.685C12.4752 11.0055 12.4146 11.3229 12.2968 11.619C12.1791 11.9151 12.0065 12.1842 11.789 12.4108C11.5714 12.6374 11.3131 12.8172 11.0288 12.9399C10.7446 13.0625 10.4399 13.1256 10.1322 13.1256C9.82451 13.1256 9.51984 13.0625 9.23557 12.9399C8.95131 12.8172 8.69302 12.6374 8.47545 12.4108C8.25788 12.1842 8.0853 11.9151 7.96755 11.619C7.8498 11.3229 7.7892 11.0055 7.7892 10.685C7.7892 10.0377 8.03605 9.41693 8.47545 8.95923C8.91485 8.50152 9.5108 8.24438 10.1322 8.24438C10.7536 8.24438 11.3496 8.50152 11.789 8.95923C12.2283 9.41693 12.4752 10.0377 12.4752 10.685Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.86 11.3188L10.119 10.8575V9.86565M9.6558 6.02252H4.7538",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTime);
export default __webpack_public_path__ + "static/media/Calendar_Time.b4bff158060ed653dd34042cf745b115.svg";
export { ForwardRef as ReactComponent };